import { useFocusEffect } from '@react-navigation/native';
import { useCallback, useEffect, useRef } from 'react';
import { getCategoryExpenses, getMerchantExpenses } from 'actions';
import { useAppDispatch, useAppSelector } from 'store/hooks';
import { selectCategoryExpenses, selectHasPendingCategoryEdits, } from '../selectors';
const useSyncMonthlyExpenses = (params) => {
    const { monthStartDate, monthEndDate, categoryId, merchantId, accountIds, runOnMount, } = params || {};
    const categoryExpenses = useAppSelector((store) => selectCategoryExpenses(store, categoryId ?? merchantId));
    const hasPendingCategoryEdits = useAppSelector(selectHasPendingCategoryEdits);
    const dispatch = useAppDispatch();
    const hasMounted = useRef(false);
    const id = categoryId ?? merchantId;
    const isFetchingExpenses = categoryExpenses?.isFetching;
    const period = `${monthStartDate}|${monthEndDate}`;
    useFocusEffect(useCallback(() => {
        if (!monthStartDate ||
            !monthEndDate ||
            id == null ||
            hasPendingCategoryEdits ||
            (!runOnMount && !hasMounted.current)) {
            return;
        }
        if (categoryId) {
            dispatch(getCategoryExpenses(monthStartDate, monthEndDate, categoryId, accountIds));
        }
        else if (merchantId) {
            dispatch(getMerchantExpenses(monthStartDate, monthEndDate, merchantId, accountIds));
        }
    }, [
        accountIds,
        categoryId,
        hasPendingCategoryEdits,
        id,
        merchantId,
        monthEndDate,
        monthStartDate,
        runOnMount,
    ]));
    useEffect(() => {
        hasMounted.current = true;
    }, []);
    const transactions = categoryExpenses?.transactions?.[period];
    return [
        transactions ?? [],
        (Boolean(isFetchingExpenses) || hasPendingCategoryEdits) && !transactions,
    ];
};
export default useSyncMonthlyExpenses;
